 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "static/js/" + ({}[chunkId]||chunkId) + "." + {"chunk-01eee779":"5760df3d","chunk-04d2875e":"5c051399","chunk-0be9ba37":"97f28049","chunk-0d64a972":"b549d537","chunk-0ed69447":"6b437b31","chunk-166b0b3c":"3d3b98e7","chunk-1c43cc4c":"8386a8d1","chunk-2109439c":"90d5cb4e","chunk-23db6532":"9e882c04","chunk-245fa91a":"b5c17206","chunk-11394152":"12399ad3","chunk-25b9c3ec":"efb521eb","chunk-2fffedb8":"adedb4e4","chunk-38c809fc":"b5b1877a","chunk-3908d609":"2dfd597a","chunk-67614913":"930fe7b7","chunk-7591678a":"a05ea7db","chunk-779d71c8":"b7e17965","chunk-8e1018f4":"fd3ed724","chunk-a197bc70":"8ec540db","chunk-b36f4060":"375208c3","chunk-25caee8a":"49ffa591","chunk-25e680cc":"9dc413f6","chunk-2b028a24":"b01e9fd7","chunk-2b29465f":"f69c1fa3","chunk-2d9942d2":"7b280e5c","chunk-304e0a4a":"2018b56a","chunk-3632805e":"338246f1","chunk-4331af7b":"82835240","chunk-4a1d1606":"41af3e5c","chunk-4e3f84e0":"fcfb72e1","chunk-585f2d80":"f81a99f9","chunk-5a1b303d":"e8bd725d","chunk-5a7b184c":"dcf3141e","chunk-612eeb7f":"35527e88","chunk-63b46b18":"f9ff9d1e","chunk-6a0e6376":"1c7d9ced","chunk-6d8c096a":"17b55ba9","chunk-9838d694":"67466e58","chunk-d1f2e912":"e055e792","chunk-d7c6f4e4":"3988201f","chunk-e9eed5da":"96058b92","chunk-fb545132":"acb1a0ee"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-01eee779":1,"chunk-04d2875e":1,"chunk-0be9ba37":1,"chunk-0d64a972":1,"chunk-0ed69447":1,"chunk-166b0b3c":1,"chunk-1c43cc4c":1,"chunk-2109439c":1,"chunk-23db6532":1,"chunk-11394152":1,"chunk-25b9c3ec":1,"chunk-2fffedb8":1,"chunk-38c809fc":1,"chunk-3908d609":1,"chunk-67614913":1,"chunk-7591678a":1,"chunk-779d71c8":1,"chunk-8e1018f4":1,"chunk-a197bc70":1,"chunk-b36f4060":1,"chunk-25caee8a":1,"chunk-25e680cc":1,"chunk-2b028a24":1,"chunk-2b29465f":1,"chunk-2d9942d2":1,"chunk-304e0a4a":1,"chunk-3632805e":1,"chunk-4331af7b":1,"chunk-4a1d1606":1,"chunk-4e3f84e0":1,"chunk-585f2d80":1,"chunk-5a1b303d":1,"chunk-5a7b184c":1,"chunk-612eeb7f":1,"chunk-63b46b18":1,"chunk-6a0e6376":1,"chunk-6d8c096a":1,"chunk-9838d694":1,"chunk-d1f2e912":1,"chunk-d7c6f4e4":1,"chunk-e9eed5da":1,"chunk-fb545132":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "static/css/" + ({}[chunkId]||chunkId) + "." + {"chunk-01eee779":"475e0f99","chunk-04d2875e":"4651e150","chunk-0be9ba37":"e90903be","chunk-0d64a972":"0514d2de","chunk-0ed69447":"df67bb94","chunk-166b0b3c":"f8981551","chunk-1c43cc4c":"d717b32d","chunk-2109439c":"ba259a4e","chunk-23db6532":"f1d64415","chunk-245fa91a":"31d6cfe0","chunk-11394152":"7aeb41c7","chunk-25b9c3ec":"1004987d","chunk-2fffedb8":"92d3cecb","chunk-38c809fc":"2bf62a43","chunk-3908d609":"d7696091","chunk-67614913":"7b3c1012","chunk-7591678a":"dc94c292","chunk-779d71c8":"2d113c72","chunk-8e1018f4":"3a90f0e8","chunk-a197bc70":"81b0ad0c","chunk-b36f4060":"6486131e","chunk-25caee8a":"5602ec6b","chunk-25e680cc":"e49ee554","chunk-2b028a24":"92cc2700","chunk-2b29465f":"d986d0c4","chunk-2d9942d2":"a98202c7","chunk-304e0a4a":"eebd20d6","chunk-3632805e":"4f2bc96c","chunk-4331af7b":"e3c1d380","chunk-4a1d1606":"65d2d122","chunk-4e3f84e0":"83d975f6","chunk-585f2d80":"1191238e","chunk-5a1b303d":"42323bb5","chunk-5a7b184c":"92ac6d06","chunk-612eeb7f":"35ce0da2","chunk-63b46b18":"bae69cb2","chunk-6a0e6376":"b4995bf6","chunk-6d8c096a":"d0c6f536","chunk-9838d694":"3573bc6b","chunk-d1f2e912":"5d84bfd6","chunk-d7c6f4e4":"b25187fa","chunk-e9eed5da":"ea00e491","chunk-fb545132":"01d6d8f0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/water-info/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
